export enum FlowMode {
    PAN = 'PAN',
    SELECTION = 'SELECTION'
}
